import { Helmet } from "react-helmet";
import "./App.css"
import Home from "./Home";
import Into from "./Into";
import Navbar from "./Navbar";
import useStore from "./store";
import { AnimatePresence, delay, motion, useInView } from 'framer-motion';
import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import About from "./About";
import Projects from "./Projects";
import Contact from "./Contact";




function App() {

  const [textColor, setTextColor] = useState('black');
  const counter = useStore(state => state.count1);

  const handleScroll = () => {
    const sectionTwo = document.getElementById('bl');
    const sectionone = document.getElementById('nav');

    if (sectionTwo && sectionone) {
      const rect = sectionTwo.getBoundingClientRect();
      const home = sectionone.getBoundingClientRect();
      console.log(home.height, rect.top, rect.height)
      if (rect.top <= home.height  && rect.top >= -rect.height) {
        setTextColor('white');
      } else {
        setTextColor('black');
      }
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  // const showAnimation = useIntro();




  return (

    <main className="App min-h-[calc(100svh-81px)]   " id="app" >

      <Routes>
        <Route path="/" element={<>
          {counter !== 107 ?
            <motion.div
              key="pop"
              exit={{ opacity: 0, y: "100%", display: "none" }}
              initial={{ opacity: 1, y: "0%" }}
              animate={counter === 107 ? { display: "block", y: "-100%" } : " "}
              transition={{ duration: 2, ease: "easeOut" }}
            // viewport={{ once: true }} 
            // whileInView="visible"


            >

              <Into />
            </motion.div>
            :
            <motion.div
              key="po"

              exit={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, display: "block" }}
              transition={{ duration: 1, ease: "easeIn" }}
            >
              <div >


                <Navbar textColor={textColor} />
                <Home />



              </div>
            </motion.div>
          }

        </>
        } />

        <Route path="/about" element={<>
          <About />
        
        </>} />
        <Route path="/projects" element={<>
          <Projects />
        
        </>} />
        <Route path="/contact" element={<>
          <Contact />
        
        </>} />


      </Routes>

    </main>


    /*        
            
            { counter !== 107 ?
             <motion.div 
                    key="pop"
                    ref={ref}
                    exit={{ opacity: 0  , display: "none"}}
                    initial={{  opacity: 1  }}
                    animate={counter === 107 && inView ? { opacity: 0, display: "block" } : " "}
                    transition={{ duration: 6 , ease :"easeOut" }}
                    viewport={{ once: true }} 
                    whileInView="visible"
           
            
            >
    
             <Into />
            </motion.div>
              : 
              <motion.div
              key="po"
                 
                    exit={{ opacity: 1 }}
                    initial={{  opacity: 0  }}
                    animate={counter === 107 ? { opacity: 1, display: "block"  } : " "}
                    transition={{ duration: 1 , ease :"easeIn"  }}
              > 
                <div >
    
             
              <Navbar textColor={textColor}  />
                <Home />
            
          
     
                </div>
               </motion.div>
             } 
          </section> */
    // </main>
  );
}

export default App;
